import {getVerticalGroupsForField} from '../../../models/vertical-group'
import {useFilteredGroups} from './use-filtered-groups'
import {useVerticalGroupedBy} from './use-vertical-grouped-by'

/**
 * Calls the useFilteredGroups hook with the current vertical grouping field, as well as
 * a function for determining the list of groups for a given field.
 * @returns An array of groups, or undefined if no grouping is currently active.
 */
export const useVerticalGroups = () => {
  const {groupedByColumnId} = useVerticalGroupedBy()
  return {...useFilteredGroups(groupedByColumnId, getVerticalGroupsForField), groupedByColumnId}
}
